<div class="customer-information-form-utf" id="customer-information-form-utf">
  <div class="alert-error">
    <app-alert-error></app-alert-error>
  </div>
  <div *ngIf="!showLoading">
    <div id="information-heading">
      <form [formGroup]="personalInformationFormGroup" *ngIf="showPersonalInfoSection">
        <div class="row no-gutters">
          <div class="col-12">
            <p class="heading">
              {{ cfetLabels.cfet_customer_information.tell_more_about_label }}
            </p>
            <label class="send-info-content" htmlFor="subheading" id="subheading" [innerHTML]="
                cfetLabels.cfet_customer_information.where_to_send_info_content
              "></label>
          </div>
          <div class="col-12" id="email-input">
            <label for="userid" id="userid" *ngIf="!displayUserID">{{
              cfetLabels.cfet_customer_information.userid
              }}</label>
            <label htmlFor="userid" id="userid" *ngIf="displayUserID">{{
              cfetLabels.cfet_customer_information.att_fnID
              }}</label>
          </div>

          <div *ngIf="!displayUserID" class="col-12 form-row email-inputbox" id="email-inputbox" [class.error]="
              emailAddressError || emailAddressEmpty || emailAlreadyExists
            ">
            <label for="email" id="email" class="emaillabel">{{
              cfetLabels.cfet_customer_information.personalemail
              }}</label>
            <input id="email" class="email" name="email" tabindex="0" formControlName="emailAddress" maxlength="256"
              placeholder="" type="text" restrict-input="restrictEmailforSpace"
              (keyup)="validateEmailAddress('personal')" (change)="onChangeEmail()" #inputEmail autocomplete="off" />
            <div *ngIf="
                emailAddressError || emailAddressEmpty || emailAlreadyExists
              " role="alert" [attr.aria-atomic]="true" [ngClass]="{
                'error-msg':
                  emailAddressError || emailAddressEmpty || emailAlreadyExists
              }">
              <em class="icon-badgealert" aria-hidden="true"></em>
              <span *ngIf="emailAddressError">{{
                cfetMessages.valid_email
                }}</span>
              <span *ngIf="emailAddressEmpty">{{
                cfetMessages.empty_email
                }}</span>
              <span *ngIf="emailAlreadyExists">{{ cfetMessages.email_exists1 }}
                <a id="login-page" (click)="redirectToLogin($event)" (keyup)="redirectToLogin($event)"
                  tabindex="0">login</a>
                {{ cfetMessages.email_exists2 }}
              </span>
            </div>
          </div>
          <div class="col-12" *ngIf="displayUserID">
            <span id="userID">{{ userID }}</span>
            <p id="utf_FNID">
              {{ cfetLabels.cfet_customer_information.utf_FNID }}
            </p>
          </div>

          <div class="col-12" id="this-email" [ngClass]="
              emailAddressError || emailAddressEmpty || emailAlreadyExists
                ? 'mt-15'
                : ''
            ">
            <span *ngIf="!displayUserID" id="eId_asUid">{{
              cfetMessages.email_id_asUser_id
              }}</span>
          </div>
        </div>

        <div class="row no-gutters">
          <div class="col-12" id="accordion_form">
            <div app-abs-accordion role="tablist" id="ac1" class="tiny-accordion">
              <app-abs-accordion-group id="personal-information-acc" heading="Personal information"
                [(isOpen)]="OpenPersonalDetails">
                <div app-abs-head class="accordion-header">
                  <em abs-expand-collapse-toggle [ngClass]="{
                      'icon-accordion-plus': !OpenPersonalDetails,
                      'icon-accordion-minus': OpenPersonalDetails
                    }" aria-label="Toggle Chevron"></em>
                  <div class="row accordian-header-title" abs-expand-collapse-toggle abs-accessibility-click="13,32"
                    [tabindex]="0">
                    <p id="personal_info">
                      {{
                      cfetLabels.cfet_customer_information.personalInformation
                      }}
                    </p>
                  </div>
                </div>

                <div app-abs-body class="employeePersonalInfo" id="employeePersonalInfo">
                  <label for="info-content" id="info-content" [innerHTML]="
                      cfetLabels.cfet_customer_information.info_content
                    "></label>
                  <div class="row no-gutters" id="name-details">
                    <div class="col-lg-6 col-12 form-row" id="firstname-input" [class.error]="!isValidFirstName">
                      <label for="firstname" id="firstname-label" aria-label="First name">{{
                        cfetLabels.cfet_customer_information.firstname
                        }}</label>
                      <div class="firstname-inputbox">
                        <input id="input_first_name" class="firstname" [(ngModel)]="fName" name="input_first_name"
                          tabindex="0" formControlName="firstName" aria-label="First name" autocomplete="off"
                          restrict-input="restrictforName" maxlength="256" type="text" (keyup)="checkFirstname()" />
                        <div *ngIf="!isValidFirstName" role="alert" [attr.aria-atomic]="true"
                          [ngClass]="{ 'error-msg': !isValidFirstName }">
                          <em class="icon-badgealert" aria-hidden="true"></em>
                          <span *ngIf="!isValidFirstName">{{
                            cfetMessages.first_name_error
                            }}</span>
                        </div>
                      </div>
                    </div>

                    <div class="col-lg-6 col-12 form-row" id="lastname-input" [class.error]="!isValidLastName">
                      <label for="lastname" id="lastname-label" aria-label="Last name">{{
                        cfetLabels.cfet_customer_information.lastname
                        }}</label>
                      <div class="lastname-inputbox">
                        <input id="input_last_name" class="lastname" [(ngModel)]="lName" name="input_last_name"
                          tabindex="0" formControlName="lastName" aria-label="Last name" autocomplete="off"
                          restrict-input="restrictforName" maxlength="256" type="text" (keyup)="checkLastname()" />
                        <div *ngIf="!isValidLastName" role="alert" [attr.aria-atomic]="true"
                          [ngClass]="{ 'error-msg': !isValidLastName }">
                          <em class="icon-badgealert" aria-hidden="true"></em>
                          <span *ngIf="!isValidLastName">{{
                            cfetMessages.last_name_error
                            }}</span>
                        </div>
                      </div>
                    </div>

                    <div class="col-lg-6 col-12 form-row" id="address1-input" [class.error]="personalAddressError">
                      <label for="address1" id="address1-label">{{
                        cfetLabels.cfet_customer_information.address1
                        }}</label>
                      <div class="address1-inputbox">
                        <input id="address1" class="address1" name="address1" tabindex="0"
                          formControlName="address1Value" maxlength="256" (keydown)="keyDownHandler($event)"
                          (paste)="pasteHandler($event)" type="text" autocomplete="off" (keyup)="checkAddress()"
                          (keyup)="autoPopulateAPI()" />
                        <div id="search-result" *ngIf="displaySearchResult || noResultFound">
                          <div id="workplace-link" *ngIf="noResultFound">
                            <p id="manually-enter">
                              {{
                              cfetLabels.cfet_customer_information
                              .no_results_found
                              }}
                            </p>
                          </div>
                          <ul id="address-field-list" role="menu" *ngIf="displaySearchResult">
                            <li id="address-field-details" *ngFor="let row of addressList; let i = index"
                              (click)="onChangeaddress($event, row)" (keyup)="onChangeaddress($event, row)"
                              tabindex="0">
                              <p>
                                <span>{{ row.street_line }},</span>
                                <span *ngIf="row.secondary">{{ row.secondary }},</span>
                                <span>{{ row.city }},{{ row.state }}
                                  {{ row.zipcode }}</span>
                                <span *ngIf="row.entries !== 0">
                                  ({{ row.entries }})</span>
                              </p>
                            </li>
                          </ul>
                        </div>
                        <div *ngIf="personalAddressError" role="alert" [attr.aria-atomic]="true"
                          [ngClass]="{ 'error-msg': personalAddressError }">
                          <em class="icon-badgealert" aria-hidden="true"></em>
                          <span *ngIf="personalAddressError">{{
                            cfetMessages.address_line
                            }}</span>
                        </div>
                      </div>
                    </div>

                    <div class="col-lg-6 col-12 form-row" id="address2-input">
                      <label for="address2" id="address2-label">{{
                        cfetLabels.cfet_customer_information.address2
                        }}</label>
                      <div class="address2-inputbox">
                        <input id="address2" class="address2" name="address2" tabindex="0"
                          formControlName="address2Value" maxlength="256" (keydown)="keyDownHandler($event)"
                          (paste)="pasteHandler($event)" type="text" placeholder="Building, suite, floor, (optional)"
                          aria-label="Home address line 2" autocomplete="off" />
                      </div>
                    </div>

                    <div class="col-lg-4 col-12 form-row" id="city-input" [class.error]="cityError">
                      <label for="city" id="city-label">{{
                        cfetLabels.cfet_customer_information.city
                        }}</label>
                      <div class="city-inputbox">
                        <input id="city" class="city" name="city" tabindex="0" formControlName="cityValue"
                          maxlength="40" (keydown)="keyDownHandler($event)" (paste)="pasteHandler($event)" type="text"
                          aria-label="City" autocomplete="off" restrict-input="restrictforModalCity"
                          (keyup)="checkCity()" />
                      </div>
                      <div *ngIf="cityError" role="alert" [attr.aria-atomic]="true"
                        [ngClass]="{ 'error-msg': cityError }">
                        <em class="icon-badgealert" aria-hidden="true"></em>
                        <span *ngIf="cityError">{{ cfetMessages.city }}</span>
                      </div>
                    </div>

                    <div class="col-lg-4 col-6 form-row row-dropdown" id="row-dropdown" [class.error]="stateError">
                      <label for="select_state" id="state-label">{{
                        cfetLabels.cfet_customer_information.state
                        }}</label>
                      <div class="field-group state-dropdown">
                        <div [ngClass]="checkState ? 'dropdown-opened' : ''">
                          <abs-dropdown [drId]="'select_state'" [drName]="'stateValue'"
                            [(dropdownValue)]="stateValueOption" formControlName="stateValue" [optionRepeat]="stateList"
                            (dropdownValueChange)="onChangeState($event)" (click)="onClickState($event)"
                            (keyup)="checkStateFn()" ngDefaultControl>
                          </abs-dropdown>
                        </div>
                        <div *ngIf="stateError" role="alert" [attr.aria-atomic]="true"
                          [ngClass]="{ 'error-msg': stateError }">
                          <em class="icon-badgealert" aria-hidden="true"></em>
                          <span *ngIf="stateError">{{
                            cfetMessages.state
                            }}</span>
                        </div>
                      </div>
                    </div>

                    <div class="col-lg-4 col-6 form-row" id="zipcode-input" [class.error]="zipcodeError">
                      <label for="zipcode" id="zipcode-label">{{
                        cfetLabels.cfet_customer_information.zipcode
                        }}</label>
                      <div class="zipcode-inputbox">
                        <input id="zipcode" class="zipcode" name="zipcode" tabindex="0" formControlName="zipCode"
                          maxlength="5" type="text" restrict-input="restrictUTFzipcode" aria-label="Zipcode"
                          autocomplete="off" (keyup)="checkZip()" />
                      </div>
                      <div *ngIf="zipcodeError" role="alert" [attr.aria-atomic]="true"
                        [ngClass]="{ 'error-msg': zipcodeError }">
                        <em class="icon-badgealert" aria-hidden="true"></em>
                        <span *ngIf="zipcodeError">{{
                          cfetMessages.valid_zipcode
                          }}</span>
                      </div>
                    </div>

                    <div class="col-lg-6 col-12 form-row" id="dob-input" [class.error]="
                        !isValidDob || (isValidDob && customerAge < 16)
                      ">
                      <label for="dob" id="dob-label">{{
                        cfetLabels.cfet_customer_information.dob
                        }}</label>
                      <div class="dob-inputbox">
                        <input id="dob" class="dob" name="dob" tabindex="0" formControlName="dateOfBirth" maxlength="10"
                          type="text" placeholder="mm/dd/yyyy" restrict-input="dob" autocomplete="off"
                          (keyup)="formatDOB($event)" (keyup)="checkDOB()" />
                      </div>
                      <div *ngIf="!isValidDob || (isValidDob && customerAge < 16)" [ngClass]="{
                          'error-msg':
                            !isValidDob || (isValidDob && customerAge < 16)
                        }" role="alert" [attr.aria-atomic]="true">
                        <em class="icon-badgealert" aria-hidden="true"></em>
                        <span *ngIf="!isValidDob">{{
                          cfetMessages.dob_error
                          }}</span>
                        <span *ngIf="isValidDob && customerAge < 16">{{
                          cfetMessages.personal_info_dob_error
                          }}</span>
                      </div>
                    </div>

                    <div class="col-lg-6 col-12 form-row" id="mobileno-input" [class.error]="phoneNumberError">
                      <label for="mobileno" id="mobileno-label">{{
                        cfetLabels.cfet_customer_information.wirelessnumber
                        }}</label>
                      <div class="mobileno-inputbox">
                        <input id="mobileno" class="mobileno" name="mobileno" tabindex="0"
                          formControlName="mobilenumber" maxlength="10" type="text" placeholder="xxx.xxx.xxxx"
                          appPhoneMask autocomplete="off" (keyup)="checkPhoneNumber()" />
                        <div *ngIf="phoneNumberError" role="alert" [attr.aria-atomic]="true"
                          [ngClass]="{ 'error-msg': phoneNumberError }">
                          <em class="icon-badgealert" aria-hidden="true"></em>
                          <span *ngIf="phoneNumberError">{{
                            cfetMessages.mobile_number_error
                            }}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </app-abs-accordion-group>
            </div>
          </div>
        </div>
<!-- Organization infromation -->
        <div class="row no-gutters" *ngIf="shouldShowOrgInfoUI()">
          <div class="col-12" id="accordion_form">
            <div app-abs-accordion role="tablist" id="ac1" class="tiny-accordion">
              <app-abs-accordion-group id="org_info" heading="Organisation information" [(isOpen)]="OpenOrgDetails">
                <div app-abs-head class="accordion-header">
                  <em abs-expand-collapse-toggle [ngClass]="{
                      'icon-accordion-plus': !OpenOrgDetails,
                      'icon-accordion-minus': OpenOrgDetails
                    }" aria-label="Toggle Chevron"></em>
                  <div class="row accordian-header-title" abs-expand-collapse-toggle abs-accessibility-click="13,32"
                    [tabindex]="0">
                    <p id="organisation-info">
                      {{
                      cfetLabels.cfet_customer_information
                      .organisationInformation
                      }}
                    </p>
                  </div>
                </div>

                <div app-abs-body class="org_info" id="org_info">
                  <p class="section-margin">
                    {{cfetLabels.cfet_customer_information.check_eligibility_info}}
                  </p>
                  <div *ngIf="affiliationCode && (!checkOraRequiredAttribute('agencyEmail') || !isDomainListEmpty())">
                    <div class="work-email row no-gutters"*ngIf="isOraEnabled() || !isDomainListEmpty()">
                      <div class="label-txt col-12">
                        <p class="ora-parameters" [ngClass]="{'error-color': workEmailAddressError}">
                          <strong>
                            {{cfetLabels.cfet_customer_information.work_email}}
                            <app-message-tooltip *ngIf="!isDomainListEmpty()" [id]="'workEmailTooltip'"
                              [message]="cfetLabels.cfet_customer_information.work_email_tooltip" [dataPlacement]="'top'">
                            </app-message-tooltip></strong>
                        </p>
                      </div>
                    </div>

                    <div class="col-12 no-gutters form-row align-items-center" id="workemail-input"
                      *ngIf="isDomainListEmpty()" [class.error]="workEmailAddressError">
                      <div class="email-inputbox col-12">
                        <input id="workemail" class="workemail" name="workemail" tabindex="0"
                          formControlName="workEmailAddress" maxlength="256" placeholder="" type="text"
                          (keyup)="validateEmailAddress('work')" restrict-input="restrictEmailforSpace"
                          autocomplete="off" />
                        <div *ngIf="workEmailAddressError" role="alert" [attr.aria-atomic]="true"
                          [ngClass]="{ 'error-msg': workEmailAddressError }">
                          <em class="icon-badgealert" aria-hidden="true"></em>
                          <span>{{cfetMessages.valid_email}}</span>
                        </div>
                      </div>
                    </div>

                    <div class="col-12 no-gutters form-row align-items-center" id="workemail-input"
                      *ngIf="!isDomainListEmpty()">
                      <div class="email-inputbox col-12" style="flex:2;">
                        <input id="workemail" class="workemail" name="workemail" tabindex="0" maxlength="256"
                          formControlName="workEmailAddress" placeholder="" type="text"
                          (input)="filterAlphaNumeric($event)" autocomplete="off" />
                      </div>
                      <span class="mx-2" style="font-size:1.6em;">&nbsp;&#64;</span>
                      <div id="field-group" class="domain-dropdown pl-2" style="flex:2; border:none;outline:none">
                        <abs-dropdown [drId]="'select_domain'" [drName]="'domainValue'" formControlName="domainValue"
                          [optionRepeat]="domainList" (dropdownValueChange)="selectDomain($event)"
                          [dropdownValue]="domainValueOption" [disabled]="isDomainListEmpty()" ngDefaultControl>
                          {{cfetLabels.cfet_customer_information.domain_dropdown_label}}
                        </abs-dropdown>
                      </div>
                    </div>
                  </div>
                  <div *ngIf="!affiliationCode">
                    <div class="work-email row no-gutters"*ngIf="!checkOraRequiredAttribute('agencyEmail')">
                      <div class="label-txt col-12">
                        <p class="ora-parameters" [ngClass]="{'error-color': workEmailAddressError}">
                          <strong>{{cfetLabels.cfet_customer_information.work_email}}</strong>
                        </p>
                      </div>

                      <div class="col-12 no-gutters form-row" id="workemail-input"
                        [class.error]="workEmailAddressError">
                        <div class="email-inputbox col-12">
                          <input id="workemail" class="workemail" name="workemail" tabindex="0"
                            formControlName="workEmailAddress" maxlength="256" placeholder="" type="text"
                            (keyup)="validateEmailAddress('work')" restrict-input="restrictEmailforSpace"
                            autocomplete="off" />
                          <div *ngIf="workEmailAddressError" role="alert" [attr.aria-atomic]="true"
                            [ngClass]="{ 'error-msg': workEmailAddressError }">
                            <em class="icon-badgealert" aria-hidden="true"></em>
                            <span *ngIf="workEmailAddressError">{{
                              cfetMessages.valid_email
                              }}</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="section-margin row no-gutters" *ngIf="!checkOraRequiredAttribute('employeeId')">
                    <div class="label-txt col-12">
                      <p class="ora-parameters"[ngClass]="{'error-color': workIdError}">
                        <strong>{{cfetLabels.cfet_customer_information.employee_id}}</strong>
                      </p>
                    </div>

                    <div class="col-12 row no-gutters form-row" id="workidnumber-input" [class.error]="workIdError">
                      <div class="email-inputbox col-12">
                        <input id="workidnumber" class="workidnumber" name="workidnumber" tabindex="0"
                          formControlName="workidnumber" maxlength="256" minlength="4" placeholder="" type="text"
                          restrict-input="restrictIdforSpace" (keyup)="checkWorkId()" autocomplete="off" />
                        <div *ngIf="workIdError" role="alert" [attr.aria-atomic]="true"
                          [ngClass]="{ 'error-msg': workIdError }">
                          <em class="icon-badgealert" aria-hidden="true"></em>
                          <span *ngIf="workIdError">{{
                            cfetMessages.valid_employeeID
                            }}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </app-abs-accordion-group>
            </div>
          </div>
        </div>
        <div class="row no-gutters" id="customerInfo-footer-column2">
          <div class="col-12 footer-content" id="footer-content">
            <p class="footer-txt" [innerHTML]="
                cfetLabels.cfet_customer_information.footer_text
              "></p>
            <hr />
          </div>
        </div>

        <div class="row no-gutters" id="customerInfo-footer-column1">
          <div id="customerInfo-footer-buttons" class="col-12 btn-container">
            <a data-dismiss="modal" (click)="cancelModal($event)" (keyup)="cancelModal($event)" tabindex="0"
              id="cancel_link">
              {{ cfetButtonLabels.button_labels.cancel }}</a>
            <button tabindex="0" type="button" id="back-btn" (click)="goBack($event)" (keyup)="goBack($event)">
              {{ cfetButtonLabels.button_labels.back }}
            </button>
            <button type="button" id="btn-submit" (click)="submit($event)" (keyup)="submit($event)" tabindex="0"
              [disabled]="disabledSubmitButton">
              {{ cfetButtonLabels.button_labels.submit }}
            </button>
          </div>
        </div>
      </form>

      <div class="row" id="customer-instant-verification-container" *ngIf="showInstantVerificationSection">
        <div class="col-md-12" id="customer-instant-verification">
          <app-customer-instant-verification-utf (showCancelModal)="displayCancelModal($event)"
            (clearTimeout)="clearTimeout($event)"></app-customer-instant-verification-utf>
        </div>
      </div>

      <div class="row" id="customer-verification-notrequired-container" *ngIf="showVerificationNotRequired">
        <div id="customer-verification-notrequired">
          <app-customer-verification-notrequired-utf (showCancelModal)="displayCancelModal($event)"
            (clearTimeout)="clearTimeout($event)">
          </app-customer-verification-notrequired-utf>
        </div>
      </div>

      <div class="row" id="customer-documents-upload-container" *ngIf="showDocUploadSection">
        <div class="col-12" id="customer-documents-upload">
          <app-customer-documents-upload-utf (goToDocReceived)="goToDocReceived($event)"
            [selectedWorkPlace]="selectedWorkPlace" [fname]="fname" [lname]="lname" [workDept]="workDept"
            [programId]="programId">
          </app-customer-documents-upload-utf>
        </div>
      </div>

      <div class="row" id="customer-verification-pending-container" *ngIf="showVerificationPending">
        <div class="col-md-12" id="customer-verification-pending">
          <app-customer-verification-pending-utf (goToDocUpload)="goToDocUpload($event)">
          </app-customer-verification-pending-utf>
        </div>
      </div>

      <div class="row" id="customer-document-review-container" *ngIf="showDocReviewPending">
        <div class="col-md-12" id="doc-review-pending">
          <app-customer-documents-review-utf (showCancelModal)="displayCancelModal($event)"
            (clearTimeout)="clearTimeout($event)">
          </app-customer-documents-review-utf>
        </div>
      </div>
    </div>
  </div>
</div>
<app-custom-spinner *ngIf="showLoading"></app-custom-spinner>
<div [ngClass]="
    showBeforeSheerIDCancelModal
      ? 'open-eligibility-step-cancel-modal'
      : 'hide-cancel-modal'
  ">
  <app-cancel-eligibility-step-modal [openModal]="openCancelModal" (closeModal)="closeModal($event)">
  </app-cancel-eligibility-step-modal>
</div>
